<bp-picture *ngFor="let imgSrc of companiesTilesNames" src="{{ logosAssetsDir }}/{{ imgSrc }}"></bp-picture>
